import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { EwidencjaService } from '../../../@core/http/ewidencja.service';
import { WydrukcService } from '../../../@core/http/wydruk.service';
import { SumowanieKwotService } from '../../../@core/utils';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../../@core/utils/komunikaty-tabeli.service';
import { Ryczalt } from '../../../shared/models/ryczalt.model';
import { ZakresDat } from '../../../shared/models/zakres-dat.model';

@Component({
  selector: 'ngx-ryczalt',
  templateUrl: './ryczalt.component.html',
  styleUrls: ['./ryczalt.component.scss'],
})
export class RyczaltComponent implements OnInit, OnDestroy {

  dane: Ryczalt[];
  temp = [];
  zakresDat: ZakresDat;
  private ewidencjeSubscription: Subscription;
  wyswietlanieFiltrow = false;
  komunikatyTabeli: KomunikatyTabeli;

  constructor(
    private readonly ewidencjeService: EwidencjaService,
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
    private readonly wydrukService: WydrukcService,
    ) { }

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.translate.onLangChange.subscribe(() => this.odswiezKomunikatyTabeli());
  }

  ngOnDestroy(): void {
    this.ewidencjeSubscription.unsubscribe();
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.ewidencjeSubscription = this.ewidencjeService
      .getRyczalt(zakresDat)
      .subscribe(response => {
        this.temp = [...response];
        this.dane = response;
      });
  }

  sumaKwota(value: number[]) {
    return new SumowanieKwotService().suma(value);
  }

  updateFilter(event, prop) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d[prop] != null && d[prop].toString().toLowerCase().indexOf(val) !== -1) || !val;
    });
    this.dane = temp;
  }

  updateFilterMobile(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d.numerDowoduKsiegowego != null && d.numerDowoduKsiegowego.toString().toLowerCase().indexOf(val) !== -1) || 
             (d.dataWpisu != null && d.dataWpisu.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.dataUzyskaniaPrzychodu != null && d.dataUzyskaniaPrzychodu.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.uwagi != null && d.uwagi.toString().toLowerCase().indexOf(val) !== -1) ||
             !val;
    });
    this.dane = temp;
  }

  sumaPrzychodRazem(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychodRazem || 0), 0);
  }

  sumaPrzychod170(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod170 || 0), 0);
  }

  sumaPrzychod150(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod150 || 0), 0);
  }

  sumaPrzychod140(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod140 || 0), 0);
  }

  sumaPrzychod125(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod125 || 0), 0);
  }

  sumaPrzychod120(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod120 || 0), 0);
  }

  sumaPrzychod100(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod100 || 0), 0);
  }

  sumaPrzychod085(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod085 || 0), 0);
  }

  sumaPrzychod055(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod055 || 0), 0);
  }

  sumaPrzychod030(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod030 || 0), 0);
  }

  sumaPrzychod020(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychod020 || 0), 0);
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }

  exportPdf() {
    this.wydrukService.drukujEwidencjeRyczaltu(this.zakresDat).subscribe(data => {
      const blob = new Blob([data], {type: 'application/pdf'});
      saveAs(blob, 'Ewidencja_ryczałtu_' + formatDate(new Date(), 'yyyyMMdd_HHmmss', 'pl-PL') +  '.pdf');
    });
  }

  czyKolumna170() {
    return this.dane.some(e => e.przychod170 > 0);
  }

  czyKolumna150() {
    return this.dane.some(e => e.przychod150 > 0);
  }

  czyKolumna140() {
    return this.dane.some(e => e.przychod140 > 0);
  }

  czyKolumna125() {
    return this.dane.some(e => e.przychod125 > 0);
  }

  czyKolumna120() {
    return this.dane.some(e => e.przychod120 > 0);
  }

  czyKolumna100() {
    return this.dane.some(e => e.przychod100 > 0);
  }

  czyKolumna085() {
    return this.dane.some(e => e.przychod085 > 0);
  }

  czyKolumna055() {
    return this.dane.some(e => e.przychod055 > 0);
  }

  czyKolumna030() {
    return this.dane.some(e => e.przychod030 > 0);
  }

  czyKolumna020() {
    return this.dane.some(e => e.przychod020 > 0);
  }

}
